var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.203,
    height: 13.5,
    viewBox: "0 0 16.203 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #609ede;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12240",
    "data-name": "Group 12240",
    transform: "translate(6506.097 7809.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7522",
    "data-name": "Path 7522",
    className: "cls-1",
    d: "M15.012,8.8,13.136,0H1.876L0,8.8",
    transform: "translate(-6505.5 -7809.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    className: "cls-2",
    d: "M16,23.6v3.5a.748.748,0,0,1-.75.75H.75A.748.748,0,0,1,0,27.1V23.6a.748.748,0,0,1,.75-.75c.372-.014,14.423,0,14.5,0A.748.748,0,0,1,16,23.6Zm-3.875,2.75a.625.625,0,1,0-.625.625A.627.627,0,0,0,12.125,26.351Zm2,0a.625.625,0,1,0-.625.625A.627.627,0,0,0,14.125,26.351Z",
    transform: "translate(-6506 -7824.269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodb);
export default __webpack_public_path__ + "static/media/vodb.48dbb4340f0845891379af82b566b20b.svg";
export { ForwardRef as ReactComponent };